export default __webpack_public_path__ + "static/media/UpLift_Logo.e5a06115.svg";